import React from 'react';
import { ArrowRight, Zap } from 'lucide-react';

const FinalCTASection = () => {
  const scrollToProducts = () => {
    const element = document.getElementById('produtos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800">
        <img 
          src="https://images.unsplash.com/photo-1758518731027-78a22c8852ec?w=1920&q=80" 
          alt="Success"
          className="w-full h-full object-cover opacity-10"
        />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-block mb-8">
            <div className="bg-orange-500 text-white px-6 py-3 rounded-full font-bold text-lg flex items-center space-x-2 animate-pulse">
              <Zap size={24} />
              <span>Oferta Por Tempo Limitado</span>
            </div>
          </div>

          {/* Main Headline */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Pare de estudar errado.{' '}
            <span className="text-orange-400">Comece a estudar com estratégia.</span>
          </h2>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            Junte-se a mais de 1.000 alunos aprovados que transformaram seus estudos com o método de flashcards
          </p>

          {/* Benefits List */}
          <div className="grid md:grid-cols-3 gap-6 mb-12 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-3xl font-bold text-orange-400 mb-2">50%</div>
              <div className="text-white">de Desconto</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-3xl font-bold text-orange-400 mb-2">8</div>
              <div className="text-white">Disciplinas Completas</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-3xl font-bold text-orange-400 mb-2">∞</div>
              <div className="text-white">Revisões Ilimitadas</div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button 
              onClick={scrollToProducts}
              className="group bg-orange-500 text-white px-10 py-5 rounded-xl font-bold text-xl hover:bg-orange-600 transition-all duration-300 transform hover:scale-105 shadow-2xl flex items-center space-x-3"
            >
              <span>Quero Ser Aprovado</span>
              <ArrowRight className="group-hover:translate-x-1 transition-transform" size={24} />
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8 text-gray-300">
            <div className="flex items-center space-x-2">
              <span className="text-orange-400 text-2xl">✓</span>
              <span>Acesso imediato</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-orange-400 text-2xl">✓</span>
              <span>Conteúdo atualizado</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-orange-400 text-2xl">✓</span>
              <span>Garantia de qualidade</span>
            </div>
          </div>

          {/* Urgency Message */}
          <div className="mt-12 bg-white/10 backdrop-blur-sm rounded-xl p-6 border-2 border-orange-500 max-w-2xl mx-auto">
            <p className="text-white text-lg">
              <strong className="text-orange-400">Atenção:</strong> O desconto de 50% é por tempo limitado. 
              Não perca a oportunidade de estudar com o método que já aprovou milhares!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
